import React, { useState } from "react";
import { Row, Col, Card, Avatar, Typography } from "antd";
import styled from "styled-components";
import { getUserList } from "redux/selectors";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const { Text } = Typography;

const Wrapper = styled.div`
  padding: 16px;
`;

const Title = styled.h4`
  margin-bottom: 16px;
  font-weight: 600;
`;

const UserCard = styled(Card)`
  text-align: center;
  border-radius: 14px;
  background: #f2fffb;
  border: 1px solid #d1fae5;

  .ant-card-body {
    padding: 24px 16px;
  }
`;

const Name = styled(Text)`
  display: block;
  font-weight: 600;
  margin-top: 12px;
`;

const Role = styled(Text)`
  color: #6b7280;
  font-size: 13px;
`;

const DotWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  gap: 8px;
`;

const Dot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(props) => (props.active ? "#1677ff" : "#d1d5db")};
  cursor: pointer;
`;

const users = [
  {
    name: "Anna Dev",
    role: "Project Lead",
    image: "https://i.pravatar.cc/150?img=32",
  },
  {
    name: "John Abraham",
    role: "Senior Designer",
    image: "https://i.pravatar.cc/150?img=12",
  },
  {
    name: "Elisa William",
    role: "General Manager",
    image: "https://i.pravatar.cc/150?img=47",
  },
  {
    name: "Michael Ross",
    role: "HR Manager",
    image: "https://i.pravatar.cc/150?img=56",
  },
];

const RecentJoiners = ({ userList }) => {
  const [page, setPage] = useState(0);

  // Items per screen size
  const itemsPerPage =
    window.innerWidth < 576 ? 1 : window.innerWidth < 992 ? 2 : 3;




  const getRecentJoiners = (userList = []) => {
    const now = new Date();
    const currentMonth = now.getMonth(); // 0-based
    const currentYear = now.getFullYear();

    return userList.filter((user) => {
      if (!user.hireddate) return false;

      const hiredDate = new Date(user.hireddate);

      return (
        hiredDate.getMonth() === currentMonth &&
        hiredDate.getFullYear() === currentYear
      );
    });
  };

  const recentJoiners = getRecentJoiners(userList).map((u) => ({
    name: u?.fullname,
    role: u?.rolename[0] || "Employee",
    image: u.profileurl || null,
  }));

  const totalPages = Math.ceil(recentJoiners.length / itemsPerPage);

  const visibleUsers = recentJoiners.slice(
    page * itemsPerPage,
    page * itemsPerPage + itemsPerPage
  );


  console.log(userList, "userListhjfdf")

  return (
    <Wrapper>
      <Title>Recent Joiners</Title>

      <Row gutter={[16, 16]} justify="center">
        {visibleUsers.map((user, index) => (
          <Col xs={24} sm={12} md={8} key={index}>
            <UserCard>
              <Avatar src={user.image} size={80}>
                {!user.image && user.name?.[0]?.toUpperCase()}
              </Avatar>

              <Name>{user.name}</Name>
              <Role>{user.role}</Role>
            </UserCard>
          </Col>
        ))}
      </Row>

      {/* Pagination Dots */}
      <DotWrapper>
        {Array.from({ length: totalPages }).map((_, i) => (
          <Dot key={i} active={i === page} onClick={() => setPage(i)} />
        ))}
      </DotWrapper>
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  userList: getUserList(state),

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {

    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RecentJoiners);


